import React, { useState } from 'react';
import { Link } from 'react-router-dom';

import Header from '../components/Header';
import Footer from '../components/Footer';
import MobileMenu from '../components/MobileMenu';
import PopupSearch from '../components/PopupSearch';
import ScrollToTop from '../components/ScrollToTop';

const Wishlist: React.FC = () => {
 const [menuOpen, setMenuOpen] =  useState(false);
  const [wishlistItems, setWishlistItems] = useState([
    {
      id: 1,
      name: 'Petal Perfection Ring',
      price: '₹4,500',
      img: '/assets/img/product3/product-s-1-1.png',
    },
    {
      id: 2,
      name: 'Golden Chain Necklace',
      price: '₹8,200',
      img: '/assets/img/product3/product-s-1-2.png',
    },
    {
      id: 3,
      name: 'Diamond Stud Earrings',
      price: '₹6,800',
      img: '/assets/img/product3/product-s-1-3.png',
    },
  ]);

  const removeWish = (id: number) => {
    setWishlistItems(wishlistItems.filter((item) => item.id !== id));
  };

  const clearWishlist = () => {
    setWishlistItems([]);
  };

  return (
    <>
      <MobileMenu
  isOpen={menuOpen}
  onClose={() => setMenuOpen(false)}
/>
      <PopupSearch />

      <main className="main">

        <Header />

        {/* Breadcumb */}
        <div
          className="breadcumb-wrapper"
          style={{
            backgroundImage:
              "url('/assets/img/bg/breadcumb-bg-1.jpg')",
                 backgroundRepeat: 'no-repeat',
    backgroundPosition: 'center',
          }}
        >
          <img
            src="/assets/img/shapes/dot-shape.svg"
            alt="dot"
            className="breadcumb-element"
          />

          <div className="container">
            <div className="breadcumb-content">
              <h1 className="breadcumb-title">My Wishlist</h1>

              <div className="breadcumb-menu-wrap">
                <ul className="breadcumb-menu">
                  <li>
                    <Link to="/">Home</Link>
                  </li>

                  <li>Wishlist</li>
                </ul>
              </div>
            </div>
          </div>
        </div>

        {/* Wishlist Section */}
        <section className="space-top space-extra-bottom">
          <div className="container">
            <div className="row">
              <div className="col-12">

                {/* Empty Wishlist */}
                {wishlistItems.length === 0 && (
                  <div className="wishlist-empty text-center py-5">
                    <div
                      style={{
                        fontSize: '4rem',
                        marginBottom: '20px',
                      }}
                    >
                      🤍
                    </div>

                    <h3
                      style={{
                        fontFamily: "'Italiana', serif",
                        fontSize: '2rem',
                        color: '#1a1208',
                      }}
                    >
                      Your Wishlist is Empty
                    </h3>

                    <p
                      style={{
                        color: '#777',
                        marginBottom: '30px',
                      }}
                    >
                      Save your favourite jewellery here and shop them anytime.
                    </p>

                    <Link to="/shop" className="vs-btn">
                      Explore Collections
                    </Link>
                  </div>
                )}

                {/* Wishlist Items */}
                {wishlistItems.length > 0 && (
                  <div>

                    {/* Toolbar */}
                    <div className="wishlist-toolbar d-flex justify-content-between align-items-center mb-4">
                      <p className="mb-0">
                        <span>{wishlistItems.length}</span> items in your
                        wishlist
                      </p>

                      <button
                        className="vs-btn style2"
                        onClick={clearWishlist}
                      >
                        Clear All
                      </button>
                    </div>

                    {/* Products */}
                    <div className="row g-4">

                      {wishlistItems.map((item) => (
                        <div
                          className="col-lg-3 col-md-4 col-6"
                          key={item.id}
                        >
                          <div
                            className="product-style3"
                            style={{ position: 'relative' }}
                          >

                            {/* Remove Button */}
                            <button
                              onClick={() => removeWish(item.id)}
                              style={{
                                position: 'absolute',
                                top: '10px',
                                right: '10px',
                                background: '#fff',
                                border: 'none',
                                width: '30px',
                                height: '30px',
                                borderRadius: '50%',
                                cursor: 'pointer',
                                zIndex: 2,
                                fontSize: '0.9rem',
                                color: '#e00',
                              }}
                            >
                              <i className="far fa-times"></i>
                            </button>

                            {/* Product Image */}
                            <div className="product-img">
                              <img
                                src={item.img}
                                alt={item.name}
                                style={{
                                  width: '100%',
                                  height: '260px',
                                  objectFit: 'cover',
                                }}
                              />
                            </div>

                            {/* Product Content */}
                            <div className="product-content">

                              <h3 className="product-title">
                                <Link to="/shop-details">
                                  {item.name}
                                </Link>
                              </h3>

                              <span className="product-price">

                                <span className="product-price__number">
                                  {item.price}
                                </span>

                                <Link
                                  className="product-cart"
                                  to="/cart"
                                >
                                  Add to Cart
                                </Link>

                              </span>
                            </div>

                          </div>
                        </div>
                      ))}

                    </div>

                  </div>
                )}

              </div>
            </div>
          </div>
        </section>

        <Footer />

      </main>

      <ScrollToTop />
    </>
  );
};

export default Wishlist;